import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { CheckCircle, Star } from "lucide-react";

const PricingCard = ({ title, price, description, features, popular, premium, onSelect, savings }) => (
  <Card className={`relative bg-white shadow-sm hover:shadow-lg transition-shadow ${popular ? 'border-[#00a3e0] ring-2 ring-[#00a3e0]' : premium ? 'border-[#ffdd00] ring-2 ring-[#ffdd00]' : 'border-gray-200'}`}>
    {popular && (
      <Badge className="absolute -top-3 left-1/2 -translate-x-1/2 bg-[#00a3e0] text-white">
        Most Popular
      </Badge>
    )}
    {premium && (
      <Badge className="absolute -top-3 left-1/2 -translate-x-1/2 bg-[#ffdd00] text-[#071734]">
        <Star className="w-3 h-3 mr-1" /> Best Value
      </Badge>
    )}
    <CardHeader className="text-center pb-2">
      <CardTitle className="font-heading text-2xl text-[#071734]">{title}</CardTitle>
      <div className="pt-4">
        <span className="text-4xl font-bold font-mono text-[#071734]">{price}</span>
        <span className="text-gray-500 ml-1">one-time</span>
      </div>
      <CardDescription className="pt-2 text-gray-600">{description}</CardDescription>
      {savings && <p className="text-xs text-[#00a3e0] font-medium mt-1">{savings}</p>}
    </CardHeader>
    <CardContent className="space-y-4">
      <ul className="space-y-2 flex flex-col items-center">
        {features.map((feature, i) => {
          // Support for nested features: { main: "Document Name", sub: ["sub1", "sub2"] }
          if (typeof feature === 'object' && feature.main) {
            return (
              <li key={i} className="w-full max-w-[240px]">
                <div className="flex items-center gap-3 text-sm text-[#071734]">
                  <CheckCircle className={`w-4 h-4 flex-shrink-0 ${premium ? 'text-[#ffdd00]' : 'text-[#00a3e0]'}`} />
                  <span>{feature.main}</span>
                </div>
                {feature.sub && (
                  <ul className="ml-7 mt-1 space-y-1">
                    {feature.sub.map((subItem, j) => (
                      <li key={j} className="text-xs text-gray-500 flex items-center gap-2">
                        <span className="text-gray-400">-</span>
                        <span>{subItem}</span>
                      </li>
                    ))}
                  </ul>
                )}
              </li>
            );
          }
          // Regular string feature
          return (
            <li key={i} className="flex items-center gap-3 text-sm w-full max-w-[240px] text-[#071734]">
              <CheckCircle className={`w-4 h-4 flex-shrink-0 ${premium ? 'text-[#ffdd00]' : 'text-[#00a3e0]'}`} />
              <span>{feature}</span>
            </li>
          );
        })}
      </ul>
      <Button 
        data-testid={`pricing-${title.toLowerCase().replace(' ', '-')}-btn`}
        className={`w-full mt-4 ${premium ? 'bg-[#ffdd00] hover:bg-[#e6c700] text-[#071734] font-semibold' : popular ? 'bg-[#00a3e0] hover:bg-[#0085b8] text-white' : 'bg-[#071734] hover:bg-[#0a2040] text-white'}`}
        variant={popular || premium ? "default" : "default"}
        onClick={onSelect}
      >
        Select {title}
      </Button>
    </CardContent>
  </Card>
);

export default PricingCard;
